import React from 'react';
import { Box } from 'src/components/Box';
import { useAppFrame } from 'src/pages/AppFrameLayout';

interface ContainerBreakoutProps {
  children: React.ReactNode;
  smDown?: boolean;
  mdDown?: boolean;
  lgDown?: boolean;
  spacing?: number;
}

const ContainerBreakout: React.FC<ContainerBreakoutProps> = ({
  smDown,
  mdDown,
  lgDown,
  spacing = 2,
  children,
}) => {
  const { config } = useAppFrame();

  const negativeSpacing = !config.frameOnly ? -spacing : 0;
  return (
    <Box
      sx={{
        mx: {
          xs: -2,
          sm: smDown ? 0 : negativeSpacing,
          mdDown: mdDown ? 0 : negativeSpacing,
          lgDown: lgDown ? 0 : negativeSpacing,
        },
      }}
    >
      {children}
    </Box>
  );
};

export { ContainerBreakout };
